import React, { useState } from 'react';

const inputCls = 'read-only:bg-[#f3f3f3] read-only:text-[#555] read-only:cursor-not-allowed w-full h-[44px] px-3 border border-[#E3473B] text-[15px] placeholder:text-[#9a9a9a] outline-none focus:border-[#EF7300] focus:ring-1 focus:ring-[#EF7300] transition-colors';

export const KycStepOne = ({ initial, locked, onNext }) => {
  const [name, setName] = useState(initial.name);
  const [id, setId] = useState(initial.id);
  const [error, setError] = useState('');

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim() || !id.trim()) {
      setError('Please fill in your Full Name and IC / Passport number.');
      return;
    }
    onNext({ name: name.trim(), id: id.trim() });
  };

  return (
    <section data-testid="kyc-step-1">
      <h2 className="text-center font-bold text-xl sm:text-[22px] mt-10">Complete verification in simple steps!</h2>

      <div className="flex items-start gap-4 mt-12 sm:mt-16 max-w-[380px] mx-auto" data-testid="kyc-step-id-validation">
        <img src="/images/kyc/id-icon.png" alt="" className="w-[46px] h-[46px] shrink-0" />
        <div>
          <h3 className="text-[19px] leading-tight">ID Validation</h3>
          <p className="text-[14px] mt-1">Scan your ID with your camera.</p>
        </div>
      </div>

      <form onSubmit={submit} className="mt-16 sm:mt-20 max-w-[420px] mx-auto space-y-3" noValidate>
        <input
          className={inputCls}
          placeholder="your Full Name"
          value={name}
          onChange={(e) => { setName(e.target.value); setError(''); }}
          autoComplete="name"
          readOnly={locked}
          data-testid="kyc-name-input"
        />
        <input
          className={inputCls}
          placeholder="your IC number / Passport number"
          value={id}
          onChange={(e) => { setId(e.target.value); setError(''); }}
          readOnly={locked}
          data-testid="kyc-id-input"
        />
        {error && <p className="text-[13px] text-[#E3473B]" data-testid="kyc-step1-error">{error}</p>}
        <div className="pt-5 flex justify-center">
          <button
            type="submit"
            className="w-[144px] h-[44px] bg-[#EF7300] text-white font-bold text-[14px] hover:bg-[#d96800] active:scale-[0.98] transition-[background-color,transform]"
            data-testid="kyc-get-started-button"
          >
            Get Started
          </button>
        </div>
      </form>
    </section>
  );
};
